function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.75 7.6H8.9V1.75C8.9 1.51131 8.80518 1.28239 8.6364 1.1136C8.46761 0.944821 8.23869 0.85 8 0.85C7.76131 0.85 7.53239 0.944821 7.3636 1.1136C7.19482 1.28239 7.1 1.51131 7.1 1.75V7.6H1.25C1.01131 7.6 0.782387 7.69482 0.613604 7.8636C0.444821 8.03239 0.35 8.26131 0.35 8.5C0.35 8.73869 0.444821 8.96761 0.613604 9.1364C0.782387 9.30518 1.01131 9.4 1.25 9.4H7.1V15.25C7.1 15.4887 7.19482 15.7176 7.3636 15.8864C7.53239 16.0552 7.76131 16.15 8 16.15C8.23869 16.15 8.46761 16.0552 8.6364 15.8864C8.80518 15.7176 8.9 15.4887 8.9 15.25V9.4H14.75C14.9887 9.4 15.2176 9.30518 15.3864 9.1364C15.5552 8.96761 15.65 8.73869 15.65 8.5C15.65 8.26131 15.5552 8.03239 15.3864 7.8636C15.2176 7.69482 14.9887 7.6 14.75 7.6Z",
  fill: "#2A67F4",
  stroke: "#2A67F4",
  strokeWidth: 0.3
});

function SvgNewTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTask);
export default ForwardRef;